import styled from 'styled-components'

import { brandSecondary } from '../../utils/style-utils'

export default styled.a.withConfig({
  shouldForwardProp: (prop) => !prop.includes('isActive'),
})`
  position: relative;
  cursor: ${(props) => (props.isActive ? 'default' : 'pointer')};
  height: 20px;

  &:hover > svg {
    fill: ${brandSecondary};
  }

  svg {
    margin: 4px;
  }
`
